import { useQuery } from '@tanstack/react-query';
import type { HandoffStats, HandoffStatsSummary } from 'types/notificationStats';

export const HAND_STATS_QUERY_KEY = ['handoff', 'stats'] as const;

export const HANDOFF_STATS_POLL_MS = 300_000;

export const HANDOFF_STATS_SUMMARY_QUERY_KEY = ['handoff', 'stats', 'summary'] as const;

export function useHandoffStatsSummaryQuery() {
  return useQuery<HandoffStatsSummary>({
    queryKey: HANDOFF_STATS_SUMMARY_QUERY_KEY,
    queryFn: async () => {
      const res = await fetch('/api/handoff/stats/summary', { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to fetch handoff stats summary');
      return res.json();
    },
    refetchInterval: HANDOFF_STATS_POLL_MS,
    staleTime: 120_000,
  });
}

export function useHandoffStatsQuery(options?: { enabled?: boolean }) {
  return useQuery<HandoffStats>({
    queryKey: HAND_STATS_QUERY_KEY,
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const res = await fetch('/api/handoff/stats', { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to fetch handoff status');
      return res.json();
    },
    refetchInterval: HANDOFF_STATS_POLL_MS,
    staleTime: 120_000,
  });
}
